/*
 * kelltoncommerce
 * version 1.0
 * http://www.kelltoncommerce.com
 *
 * Copyright (c) 2023  kellton tech solution limited
 * Author kellton ltd <support@kellton.com>
 * Licensed under the MIT license.
 */

import { Map, Record } from 'immutable';

export interface customer extends Map<string, any> {
  purchasedCustomerList: any;
  purchasedCustomerListLoading: boolean;
  purchasedCustomerListLoaded: boolean;
  purchasedCustomerListFailed: boolean;

  purchaseCount:number;
  purchaseCountLoading:boolean;
  purchaseCountLoaded:boolean;
}

export const CustomerStateRecord = Record({
  purchasedCustomerList: [],
  purchasedCustomerListLoading: false,
  purchasedCustomerListLoaded: false,
  purchasedCustomerListFailed: false,

  purchaseCount:[],
  purchaseCountLoading:false,
  purchaseCountLoaded:false,
});
